module.exports = __webpack_public_path__ + "img/banner-bg-2x.45d5c52.jpg";